module.exports = "<div class=\"content-page content-wrapper gray settings-page\">\n    <div class=\"content\">\n        <div class=\"container\">\n            <div class=\"row mbot3\">\n                <div class=\"col-md-12\">\n                    <h2 class=\"no-m\">{{ 'titles.settings' | translate }}</h2>\n                </div>\n            </div>\n            <activation-form form=\"$ctrl.form\" on-submit=\"$ctrl.submit(payload)\"></activation-form>\n        </div>\n    </div>\n</div>\n\n<app-footer></app-footer>"


//////////////////
// WEBPACK FOOTER
// ./client/app/pages/activation/activation.html
// module id = 1514
// module chunks = 0